"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dele = exports.post = exports.put = exports.postBlob = exports.getBlob = exports.get = void 0;
require("whatwg-fetch");
function send(method, url, options, type, credentials) {
    return __awaiter(this, void 0, void 0, function* () {
        const { headers } = options;
        const body = options && options.body ? options.body : null;
        const response = yield window.fetch(url, {
            mode: 'cors',
            credentials,
            headers,
            method,
            body,
        });
        if (!response.ok) {
            try {
                // エラー時でもレスポンスボディはそのまま取得する
                const resJson = yield response.json();
                return {
                    ok: response.ok,
                    status: response.status,
                    body: resJson,
                    statusText: response.statusText,
                    contentType: response.headers.get('Content-Type') || '',
                };
            }
            catch (e) {
                return {
                    ok: response.ok,
                    status: response.status,
                    body: '',
                    statusText: response.statusText,
                    contentType: response.headers.get('Content-Type') || '',
                };
            }
        }
        let resJson;
        if (type === 'blob') {
            resJson = yield response.blob();
        }
        else if (method === 'DELETE') {
            resJson = '';
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            resJson = yield response.json();
        }
        return {
            ok: response.ok,
            status: response.status,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            body: resJson,
            statusText: response.statusText,
        };
    });
}
/**
 * GETリクエストを送信する
 *
 * #### インポート
 * ```typescript
 * import { get } from 'rj_frontend_common/dist/api/common/fetch'
 * ```
 * @param url リクエスト先URL
 * @param options HTTPリクエストヘッダー・リクエストボディ
 * @param callback エラー時のコールバック関数
 * @returns レスポンスボディ, エラー時はnullを返す
 * @typeParam T レスポンスのボディの型
 */
function get(url, options, 
/**
 * @param status HTTPステータスコード
 */
callback) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield send('GET', url, options || {});
        if (!response.ok && callback) {
            callback(response.status, response.body, response.contentType);
        }
        const resJson = response.ok ? response.body : null;
        return resJson;
    });
}
exports.get = get;
/**
 * バイナリ形式で応答を受信するGETリクエスト
 *
 * #### インポート
 * ```typescript
 * import { getBlob } from 'rj_frontend_common/dist/api/common/fetch'
 * ```
 * @param url リクエスト先URL
 * @param options HTTPリクエストヘッダー・リクエストボディ
 * @param callback エラー時のコールバック関数
 * @returns レスポンスボディ, エラー時はnullを返す
 * @typeParam T レスポンスのボディの型
 */
function getBlob(url, options, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield send('GET', url, options || {}, 'blob');
        if (!response.ok && callback) {
            callback(response.status, response.body, response.contentType);
        }
        const resJson = response.ok ? response.body : null;
        return resJson;
    });
}
exports.getBlob = getBlob;
/**
 * バイナリ形式で応答を受信するPOSTリクエスト
 *
 * #### インポート
 * ```typescript
 * import { postBlob } from 'rj_frontend_common/dist/api/common/fetch'
 * ```
 * @param url リクエスト先URL
 * @param options HTTPリクエストヘッダー・リクエストボディ
 * @param callback エラー時のコールバック関数
 * @returns レスポンスボディ, エラー時はnullを返す
 * @typeParam T レスポンスのボディの型
 */
function postBlob(url, options, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield send('POST', url, options || {}, 'blob');
        if (!response.ok && callback) {
            callback(response.status, response.body, response.contentType);
        }
        const resJson = response.ok ? response.body : null;
        return resJson;
    });
}
exports.postBlob = postBlob;
/**
 * PUTリクエスト
 *
 * #### インポート
 * ```typescript
 * import { put } from 'rj_frontend_common/dist/api/common/fetch'
 * ```
 * @param url リクエスト先URL
 * @param options HTTPリクエストヘッダー・リクエストボディ
 * @param callback エラー時のコールバック関数
 * @returns レスポンスボディ, エラー時はnullを返す
 * @typeParam T レスポンスのボディの型
 */
function put(url, options, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield send('PUT', url, options);
        if (!response.ok && callback) {
            callback(response.status, response.body, response.contentType);
        }
        const resJson = response.ok ? response.body : null;
        return resJson;
    });
}
exports.put = put;
/**
 * POSTリクエスト
 *
 * #### インポート
 * ```typescript
 * import { post } from 'rj_frontend_common/dist/api/common/fetch'
 * ```
 * @param url リクエスト先URL
 * @param options HTTPリクエストヘッダー・リクエストボディ
 * @param callback エラー時のコールバック関数
 * @returns レスポンスボディ, エラー時はnullを返す
 * @typeParam T レスポンスのボディの型
 */
function post(url, options, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield send('POST', url, options);
        if (!response.ok && callback) {
            callback(response.status, response.body, response.contentType);
        }
        const resJson = response.ok ? response.body : null;
        return resJson;
    });
}
exports.post = post;
/**
 * DELETEリクエスト
 *
 * #### インポート
 * ```typescript
 * import { dele } from 'rj_frontend_common/dist/api/common/fetch'
 * ```
 * @param url リクエスト先URL
 * @param options HTTPリクエストヘッダー・リクエストボディ
 * @param callback エラー時のコールバック関数
 * @returns レスポンスボディ, エラー時はnullを返す
 * @typeParam T レスポンスのボディの型
 */
function dele(url, options, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield send('DELETE', url, options || {});
        if (!response.ok && callback) {
            callback(response.status, response.body, response.contentType);
        }
        const resJson = response.ok ? response.body : null;
        return resJson;
    });
}
exports.dele = dele;
